import { indexData } from '@/mocks/homepage';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            漫画分类索引
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            按题材快速找到你想看的漫画类型
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5">
          {indexData.map((item) => (
            <a
              key={item.id}
              href={`#index`}
              className="group flex items-center gap-4 bg-background-100 hover:bg-background-200/70 rounded-xl p-5 transition-colors duration-200 cursor-pointer no-underline"
            >
              <div className={`w-12 h-12 rounded-xl bg-background-50 flex items-center justify-center text-xl ${item.color} flex-shrink-0`}>
                <i className={item.icon}></i>
              </div>
              <div className="min-w-0">
                <div className="font-medium text-sm text-foreground-900 mb-0.5">
                  {item.name}
                </div>
                <div className="text-xs text-foreground-500">
                  {item.count}
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}